import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, merge } from 'rxjs';
import { JourneyService } from '_services/journey.service';
import { JourneyNavView, StageStripItem } from '_services/journey';
import { QuestionService } from '_services/question.service';
import { UserService } from '_services/user.service';

@Component({
  selector: 'app-stage-nav',
  templateUrl: './stage-nav.component.html',
  styleUrls: ['./stage-nav.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StageNavComponent {
  private journey = inject(JourneyService);
  private router = inject(Router);
  private cdRef = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  private qs = inject(QuestionService);
  private us = inject(UserService);

  private readonly questionsLoaded$ = toObservable(this.qs.isLoaded);

  navView: JourneyNavView | null = null;

  constructor() {
    // Calculator shell already gates visibility — do not also wait on dependency/prefs.
    merge(
      this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)),
      this.qs.invalidTotals,
      this.questionsLoaded$,
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.refresh());

    this.refresh();
  }

  itemLink(item: StageStripItem): string[] {
    return ['/app', this.us.schoolId, item.route];
  }

  private refresh() {
    if (!this.qs.isLoaded()) {
      this.navView = null;
    } else {
      this.navView = this.journey.getNavView(this.currentRouteSegment());
    }
    this.cdRef.markForCheck();
  }

  private currentRouteSegment(): string | null {
    return this.router.url.split('?')[0].split('#')[0].split('/')[3] || null;
  }
}
